
import React from 'react';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import { Propaganda } from '../../constants/type.constant';
import { preLoadNginxImage, propagandaIcon } from '../../tools/utils';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import Store from '../../redux/store';

/**
 * 宣传媒体
 */
class MediaComponent extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.state = {
            // 宣传资料数据
            propagandaData: [],
            logoImage: '',
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    public UNSAFE_componentWillMount() {
        this.preloadQopLogo();
    }
    public componentDidMount() { }

    // public shouldComponentUpdate(nextProp: any, nextState: State) {
    //     return false
    // }

    // *********************
    // 方法区
    // *********************

    async preloadQopLogo() {
        let logoImg = `${Store.getState().serverUrl}/qop_logo/logo.jpg`;
        const newLogoImg = await preLoadNginxImage(logoImg, 'qop_logo', 'qop');
        this.setState({ logoImage: newLogoImg });
    }

    public getWebsite() {
        const IS_WEBSITE = this.props.propagandaData.find((item) => {
            return item.name === 'OFFICIAL_WEBSITE';
        });
        return IS_WEBSITE;
    }
    // *********************
    // 视图区
    // *********************

    render() {
        const { propagandaData } = this.props;
        return (
            <React.Fragment>
                {/* 社交宣传 */}
                {
                    !!propagandaData.length &&
                    <React.Fragment>
                        <div className="homeTitle">{i18n.t('auto_open_page_text_media')}</div>
                        <div style={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap' }}>
                            {
                                propagandaData.map((item, index) => {
                                    return (
                                        !!propagandaIcon(item.name) ?
                                            <div className="propagandaIcon" key={index}>
                                                <Button onClick={() => window.open(`${item.url}`)}>
                                                    {
                                                        <div>
                                                            <div style={{
                                                                width: '11vw',
                                                                height: '11vw',
                                                                background: `url(${propagandaIcon(item.name)}) no-repeat`,
                                                                backgroundSize: 'contain',
                                                            }}></div>
                                                        </div>
                                                    }

                                                </Button>
                                            </div>
                                            : null
                                    );
                                })
                            }
                        </div>
                    </React.Fragment>
                }
                {/* 官网 */}
                {
                    _.get(this.getWebsite(), 'url', '') &&
                    <React.Fragment >
                        <div className="homeTitle">{i18n.t('auto_open_page_text_website')}</div>
                        <div className="propagandaIcon-website">
                            <Button
                                onClick={() => {
                                    window.open(`${_.get(this.getWebsite(), 'url', '')}`);
                                }}
                            >
                                {
                                    <div style={{
                                        width: '11vw',
                                        height: '11vw',
                                        background: `url(${this.state.logoImage}) no-repeat`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center'
                                    }} />
                                }
                            </Button>
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }

}
export default withSnackbar(MediaComponent);

// **********
// TYPE
// **********

type Props = {
    // 宣传资料数据
    propagandaData: Array<Propaganda>;

} & WithSnackbarProps

type State = {
    // 宣传资料数据
    propagandaData: Array<Propaganda>;
    logoImage: string;
}
